const en = {
  // Auth
  login: 'Login',
  register: 'Register',
  email: 'Email',
  password: 'Password',
  name: 'Name',
  phone: 'Phone',
  confirmPassword: 'Confirm Password',
  forgotPassword: 'Forgot Password?',
  dontHaveAccount: "Don't have an account?",
  alreadyHaveAccount: 'Already have an account?',
  createAccount: 'Create Account',
  signInToAccount: 'Sign in to your account',
  
  // Navigation
  dashboard: 'Dashboard',
  workers: 'Workers',
  sites: 'Sites',
  attendance: 'Attendance',
  salary: 'Salary',
  advances: 'Advances',
  settings: 'Settings',
  profile: 'Profile',
  logout: 'Logout',
  
  // Dashboard
  welcome: 'Welcome',
  totalWorkers: 'Total Workers',
  activeToday: 'Active Today',
  totalSites: 'Total Sites',
  pendingPayments: 'Pending Payments',
  totalPendingAmount: 'Total Pending Amount',
  thisWeek: 'This Week',
  lastMonth: 'Last Month',
  totalPaid: 'Total Paid',
  totalAdvance: 'Total Advance',
  daysWorked: 'Days Worked',
  dailyRate: 'Daily Rate',
  grossAmount: 'Gross Amount',
  netAmount: 'Net Amount',
  
  // Workers
  addWorker: 'Add Worker',
  editWorker: 'Edit Worker',
  deleteWorker: 'Delete Worker',
  workerName: 'Worker Name',
  workerList: 'Worker List',
  dailySalary: 'Daily Salary',
  
  // Sites
  addSite: 'Add Site',
  editSite: 'Edit Site',
  deleteSite: 'Delete Site',
  siteName: 'Site Name',
  siteLocation: 'Site Location',
  siteDescription: 'Site Description',
  assignWorkers: 'Assign Workers',
  
  // Attendance
  checkIn: 'Check In',
  checkOut: 'Check Out',
  markAttendance: 'Mark Attendance',
  todayAttendance: "Today's Attendance",
  attendanceHistory: 'Attendance History',
  status: 'Status',
  present: 'Present',
  absent: 'Absent',
  halfDay: 'Half Day',
  
  // Salary
  calculateSalary: 'Calculate Salary',
  paymentHistory: 'Payment History',
  markAsPaid: 'Mark as Paid',
  pending: 'Pending',
  paid: 'Paid',
  weekStart: 'Week Start',
  weekEnd: 'Week End',
  
  // Advances
  requestAdvance: 'Request Advance',
  approveAdvance: 'Approve Advance',
  rejectAdvance: 'Reject Advance',
  advanceAmount: 'Advance Amount',
  advanceReason: 'Advance Reason',
  pendingRequests: 'Pending Requests',
  
  // Common
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  view: 'View',
  search: 'Search',
  filter: 'Filter',
  date: 'Date',
  from: 'From',
  to: 'To',
  loading: 'Loading...',
  noData: 'No data available',
  success: 'Success',
  error: 'Error',
  confirm: 'Confirm',
  
  // Theme
  lightMode: 'Light Mode',
  darkMode: 'Dark Mode',
  
  // Language
  bangla: 'Bangla',
  english: 'English',
};

export default en;
